import { z } from 'zod/v4';
import { IMessage, MESSAGE_SCHEMA } from '@web/dtos';

export interface IApiResponse<T> {
  data?: T;
  message?: IMessage;
}

export const API_RESPONSE_SCHEMA = <I>(
  dataSchema: z.ZodType<I>
): z.ZodType<IApiResponse<I>> =>
  z.object({
    data: dataSchema.optional(),
    message: MESSAGE_SCHEMA.optional(), // or replace with a concrete IMessageSchema
  });
